import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=92505548&"
import script from "./UserCreate.vue?vue&type=script&lang=js&"
export * from "./UserCreate.vue?vue&type=script&lang=js&"
import style0 from "./UserCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports